import http from '../utils/http'

export default {
	get(data = {}) {
		return http.get('/tournaments', data)
	},
}